import type { TabItem } from '@festina-life/ui/structure'
import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router'

import { useSafelySelectedTab } from '../../../hooks/useSafelySelectedTab'
import { getBranchDetailsNavigationState } from './branchDetailsNavigationState'

export const useActiveElementTabsState = (
  items: TabItem[],
  initialKey?: (typeof items)[number]['key'],
) => {
  const location = useLocation()
  const navigate = useNavigate()
  const { selectedIndex, onTabChange } = useSafelySelectedTab(items, initialKey)

  // Clear the navigation state after consuming it so returning to this
  // workspace through normal navigation does not re-force the initial tab.
  useEffect(() => {
    const toTab = getBranchDetailsNavigationState(location.state)
    if (!toTab?.initialTab) {
      return
    }

    void navigate(location.pathname + location.search + location.hash, {
      replace: true,
    })

    const targetIndex = items.findIndex((item) => item.key === toTab.initialTab)
    if (targetIndex >= 0) {
      onTabChange(targetIndex)
    }
  }, [location, navigate, onTabChange, items])

  return { selectedIndex, onTabChange }
}
